<template>
	<div class="space-y-7">
		<div class="border-t border-border-secondary rounded-b-lg bg-white pb-2">
			<template v-for="(link, index) in menuLinks" :key="index">
				<AbsoluteInternalLink
					v-if="link.url"
					:to="link.url"
					:target="link.target ?? '_self'"
					class="block px-4 py-3 hover:bg-orange-100 [&.router-link-active]:font-bold text-base"
					@click="handleClick(link)"
				>
					{{ link.label }}
					<NuxtIcon
						v-if="link.suffixIcon"
						:name="link.suffixIcon"
						class="text-icon-tertiary text-md inline-flex ml-1 relative top-0.5"
						filled
					/>
				</AbsoluteInternalLink>
			</template>
		</div>

		<div>
			<div class="flex items-center gap-2 mb-2">
				<div class="flex items-center gap-1.5">
					<NuxtIcon
						name="custom/globe"
						class="text-base text-icon-primary"
						filled
						aria-hidden="true"
					/>
					<h3 class="font-secondary text-neutral-900 text-sm relative">
						Globus.cz
					</h3>
				</div>
			</div>

			<div class="border-t border-border-secondary rounded-b-lg bg-white pb-2">
				<template v-for="(link, index) in menuSecondaryLinks" :key="index">
					<HeaderNavCollapseLink v-if="link.items" :link="link" @click="(label?: string) => handleClick(link, {label})" />
					<AbsoluteInternalLink
						v-else
						:to="link.url"
						class="block px-4 py-3 hover:bg-orange-100 [&.router-link-active]:font-bold text-base"
						@click="handleClick(link)"
					>
						{{ link.label }}
					</AbsoluteInternalLink>
				</template>
			</div>
		</div>

		<div>
			<div class="flex items-center gap-2 mb-3">
				<div class="flex items-center gap-1.5">
					<NuxtIcon
						name="custom/support"
						class="text-base text-icon-primary"
						filled
						aria-hidden="true"
					/>
					<h3 class="font-secondary text-neutral-900 text-sm relative">
						Zákaznická linka
					</h3>
				</div>
			</div>

			<div class="border-t border-border-secondary rounded-b-lg bg-white pb-2">
				<NuxtLink
					to="tel:800241242"
					class="px-4 py-3 hover:bg-orange-100 flex items-start gap-2 font-bold"
				>
					<NuxtIcon
						name="phone"
						class="text-xl text-icon-primary top-1 relative -scale-x-100"
						filled
						aria-hidden="true"
					/>
					<span>
						800 241 242
						<span class="text-xs block font-normal text-body-quaternary">Bezplatná linka 8:00 - 16:00</span>
					</span>
				</NuxtLink>
				<NuxtLink
					to="mailto:info@globus.cz"
					class="px-4 py-3 hover:bg-orange-100 flex items-center gap-2 font-bold"
				>
					<NuxtIcon
						name="mail"
						class="text-xl text-icon-primary relative"
						filled
						aria-hidden="true"
					/>
					<span class="">
						info@globus.cz
					</span>
				</NuxtLink>
			</div>
		</div>

		<div class="pb-2">
			<h4 class="font-secondary text-neutral-900 text-sm relative mb-2">
				Stáhnout aplikaci Můj Globus
			</h4>
			<div class="grid grid-cols-2 gap-2 max-w-xl">
				<NuxtLink to="https://play.google.com/store/apps/details?id=com.pragonauts.globus" target="_blank" @click="trackHeaderEvent('app_icons_leftside', 'Google Play')">
					<NuxtImg src="/images/google-play-2.png" alt="Google Play" loading="lazy" class="w-full" />
				</NuxtLink>
				<NuxtLink to="https://apps.apple.com/cz/app/m%C5%AFj-globus/id1425012509?l=cs" target="_blank" @click="trackHeaderEvent('app_icons_leftside', 'App Store')">
					<NuxtImg src="/images/app-store-2.png" alt="App Store" loading="lazy" class="w-full" />
				</NuxtLink>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {MenuLink} from '../../../types/header';

	type Props = {
		menuLinks: MenuLink[]
		menuSecondaryLinks: MenuLink[]
	};

	type Emits = {
		(e: 'update:click', payload: boolean): void
	};

	defineProps<Props>();

	const emit = defineEmits<Emits>();

	function handleClick(item: MenuLink, subItem?: {label?: string}) {
		trackHeaderEvent(subItem?.label ? 'text_leftside_in_selector' : 'text_leftside', `${item.label}${subItem?.label ? ` | ${subItem.label}` : ''}`);
		emit('update:click', false);
	}
</script>
